import {requestCoreMixin} from "@/api/coreApi";
import moment from "moment";

export const FileDownloadMixin = {
  mixins: [requestCoreMixin],
  methods: {
    downloadFileDocument(filename) {
      this.getFileDocument(filename)
        .then((response) => {
          this.$log.debug('getFileDocument')

          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')
          link.href = fileURL

          const date = moment().format('YYYYMMDDhhmmss')
          link.download = `${date}-${filename}`
          link.click()
        })
        .catch((err) => {
          this.$log.fatal('getFileDocument', err, err.response, err.request)
          this.showError("Error al obtener el documento")
        })
    },
  }
}
